module.exports = __webpack_public_path__ + "OpenSans-SemiBoldItalic.9750527ef62a19cddd87.eot";


//////////////////
// WEBPACK FOOTER
// C:/Users/jerd_/Documents/e-payment-public/e-payment-frontend/src/assets/customfonts/OpenSans-SemiBoldItalic.eot
// module id = ../../../../../src/assets/customfonts/OpenSans-SemiBoldItalic.eot
// module chunks = styles